module.exports = __webpack_public_path__ + "img/Longshine.b3139ab4.jpg";